import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';

// ------------------ List QR Codes -------
const getAllQRCodes = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.qrCode.list + `${filter ? '?' + filter : ''}`);
    return data;
};

const GetAllQRCodesQuery = (filter) => {
    return useQuery(['QRCodeList', filter], () => getAllQRCodes(filter));
};

// ------------------ Add QR Code -------
const addQRCode = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.qrCode.add, payload);
};

const CreateQRCodeMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addQRCode, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('QRCodeList');
            toastMessage('success', 'QR Code Created Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            const message = error?.response?.data?.message;
            toastMessage('error', desc || message || 'Server Error');
        }
    });
};

// ------------------ Update QR Code -------
const updateQRCode = async ({ id, payload }) => {
    return await HTTP_CLIENT.put(Endpiont.qrCode.update + id, payload);
};

const UpdateQRCodeMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateQRCode, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('QRCodeList');
            toastMessage('success', 'QR Code Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            const message = error?.response?.data?.message;
            toastMessage('error', desc || message || 'Server Error');
        }
    });
};

// ------------------ Delete QR Code -------
const deleteQRCode = async (id) => {
    return await HTTP_CLIENT.delete(Endpiont.qrCode.delete + id);
};

const DeleteQRCodeMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteQRCode, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('QRCodeList');
            toastMessage('success', 'QR Code Deleted Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            const message = error?.response?.data?.message;
            toastMessage('error', desc || message || 'Server Error');
        }
    });
};

export {
    GetAllQRCodesQuery,
    CreateQRCodeMutation,
    UpdateQRCodeMutation,
    DeleteQRCodeMutation
};
